import { AuthProvider } from './Assets/AuthProvider';
import { Route, Routes } from 'react-router-dom';

//Components
import PersistLogin from './Components/PersistLogin';
import RequireAuth from './Components/RequireAuth';
import Footer from './Components/Footer';
import Layout from './Components/Layout';
import Navbar from './Components/Navbar';

// Modules
import Articles from './Modules/Articles';
import Profiles from './Modules/Profiles';
import Gallery from './Modules/Gallery';
import Events from './Modules/Events';
import Admin from './Modules/Admin';
import User from './Modules/User';
import News from './Modules/News';
import Home from './Modules/Home';

//Single Pages
import Contact from './Pages/Contact';
import Apply from './Pages/Apply';
import Login from './Pages/Login';
import Pages from './Pages/Pages';


function App() {

  let IMAGE_URL = 'http://localhost:3007';
  if(process.env.NODE_ENV === 'production'){ IMAGE_URL = 'https://kampalajunioracademy.ac.ug/api'; }
  

  // let IMAGE_URL = 'https://kampalajunioracademy.ac.ug/api';
  // //let IMAGE_URL = 'http://localhost:3007';
  
  const img = `${IMAGE_URL}/images/`;

  return (
    <AuthProvider>
      <div className="App">
        <Navbar img={img}/>
        <Routes>
          <Route element={<PersistLogin />}>
            <Route path="/" element={<Layout />}>
              <Route exact path='/' element={<Home img={img}/>}/>
              <Route exact path='/profiles/*' element={<Profiles img={img}/>} />
              <Route exact path='/gallery/*' element={<Gallery img={img}/>} />
              <Route exact path='/blog/*' element={<Articles img={img}/>} />
              <Route exact path='/events/*' element={<Events img={img}/>} />
              <Route exact path='/contact' element={<Contact img={img}/>} />
              <Route exact path='/apply/*' element={<Apply img={img}/>} />
              <Route exact path='/news/*' element={<News img={img}/>} />
              <Route exact path='/login' element={<Login img={img}/>} />
              <Route element={<RequireAuth allowedRoles={[1, 2, 3, 4, 5]} />}>
                <Route exact path='/user/*' element={<User img={img}  />} />
              </Route>
              <Route element={<RequireAuth allowedRoles={[4, 5]} />}>
                <Route exact path='/admin/*' element={<Admin img={img}/>} />
              </Route>
              <Route exact path='/*' element={<Pages img={img} />} />
            </Route>
          </Route>
        </Routes>
        <Footer img={img}/>
      </div>
    </AuthProvider>
  );
}

export default App;